import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';
import TitledContent from '../TitledContent';
import PlainButton from '../PlainButton';
import Section from '../Section';

export const CongratsSection = styled(Section)`
  padding-bottom: 5px;
  ${media.desktop`
    padding-bottom: 15px;
  `}
`;

export const ProposalTitledContent = styled(TitledContent)`
  margin-top: 20px;
  align-items: center;
  > label {
    ${fontSize(10)}
  }
  > p {
    ${fontSize(20)}
  }
  ${media.desktop`
    &&{
      margin-bottom: 0;
    }
  `}
`;

export const ProductTitledContent = styled(TitledContent)`
  align-items: center;
  > label {
    font-weight: 500;
    ${fontSize(14)}
  }
  ${media.desktop`
    &&{
      margin-bottom: 0;
    }
  `}
`;

export const ProductButton = styled(PlainButton)`
  width: 60%;
  height: 40px;
`;
